﻿import React, { useState, useEffect } from 'react';
import { LocationZone } from '../../models/Locations/location-zone';
import { Bin } from '../../models/Locations/bin';
import { TreeNodeObject } from '../../models/Common/tree-node-object';
import { CrudFunctions } from '../../utilities/crud-functions';
import { ModalMetadata } from '../../models/modal-metadata';
import { ModalMessageType, TreeNodeTypes } from '../../models/enums';
import { ToastProps } from '../../models/toast-props';
import GlobalDialog from '../Modal/GlobalDialog';

import DataGrid, {
    Column,
    FilterRow,
    GroupPanel,
    Selection,
    HeaderFilter,
    Editing,
    Popup,
    Form,
    Toolbar,
    Item as ToolbarItem,
    Button as ColumnButton,
    Paging,
    Scrolling,
    SearchPanel,
    LoadPanel
} from 'devextreme-react/data-grid';

import TextBox from 'devextreme-react/text-box';
import Button from 'devextreme-react/button';
import { Popup as DialogPopup } from 'devextreme-react/popup';
import { Item } from 'devextreme-react/form';
import TreeView from 'devextreme-react/tree-view';
import { Toast } from 'devextreme-react/toast';

export default function LocationsManagementForm() {
    const [locationsTree, setLocationsTree] =
        useState<TreeNodeObject[]>();

    const [selectedZone, setSelectedZone] =
        useState<TreeNodeObject>();

    const [subItems, setSubItems] =
        useState<TreeNodeObject[]>();

    const [newLocationName, setNewLocationName] =
        useState<string>();

    const [newLocationDescription, setNewLocationDescription] =
        useState<string>();

    const [addNewLocationDialogVisible, setAddNewLocationDialogVisible] =
        useState<boolean>();

    const [toastProps, setToastProps] =
        useState<ToastProps>();

    const [globalDialogMetadata, setGlobalDialogMetadata] =
        useState<ModalMetadata>();

    const [globalDialogVisible, setGlobalDialogVisible] =
        useState<boolean>()

    useEffect(() => {
        getAllData();
    }, []);

    return (
        <div>
            <div className="pw-content">
                <div className="lq-title-bar">
                    <div className="lq-main-title">Locations Management</div>
                    <div className="title-bar-spacer" />
                    <div className="save-toolbar">
                        {/*
                        <div>
                            <NavLink to={`/documentation/${DocumentationConstants.AssetsForm}`}
                                className="pw-right-align-content" target="_blank" rel="noopener noreferrer">
                                <Button className="title-bar-button pw-orange"
                                    text="" icon="help" type="normal"
                                    hint="help and documentation" />
                            </NavLink>
                        </div>
                        */}
                    </div>
                </div>

                <div className="lq-header pw-margin-bottom-05 aurum-blue-bg">
                    <div className="lq-header-title">Zones</div>
                    <div className="title-bar-spacer" />
                    <div>
                        <Button className="title-bar-button"
                            text="" icon="plus" type="success"
                            hint="add location"
                            onClick={onAddLocationClick} />
                    </div>
                </div>
                <div style={{ border: "1px solid #aaa" }}>
                    <TreeView id="locationTree" height="20rem"
                        dataStructure="tree"
                        items={locationsTree ? locationsTree : []}
                        keyExpr="id" displayExpr="name"
                        hasItemsExpr="hasChildren"
                        itemsExpr="children"
                        onItemClick={onLocationNodeClick} />
                </div>

                {selectedZone &&
                    <div id="subItemsDataGrid" className="pw-margin-top-1 pw-margin-bottom-1">
                        <DataGrid height="16rem"
                            keyExpr="id"
                            dataSource={subItems ? subItems : []}
                            wordWrapEnabled={true}
                            allowColumnResizing={true}
                            columnResizingMode='widget'
                            onRowValidating={onSelectedSubItemRowValidating}
                            rowAlternationEnabled={true}
                            showRowLines={true}
                            showBorders={true} >

                            <LoadPanel enabled={true} />
                            <Paging enabled={false} />
                            <Selection mode='single' />
                            <HeaderFilter visible={true} />
                            <FilterRow visible={true} />
                            <GroupPanel visible={false} />
                            <SearchPanel visible={true} />
                            <Scrolling columnRenderingMode='virtual' />

                            <Column type="buttons" width={"5rem"}>
                                <ColumnButton name="edit" />
                            </Column>

                            <Column dataField='name' width={'20%'} />
                            <Column dataField='description' width={'80%'} />

                            <Toolbar>
                                <ToolbarItem location='before'>
                                    <div className="pw-datagrid-toolbar-template">
                                        <div className="pw-datagrid-toobar-title">{`${selectedZone && selectedZone.name}`}</div>
                                    </div>
                                </ToolbarItem>
                                <ToolbarItem name="addRowButton" location='after' />
                                <ToolbarItem name="searchPanel" location='after' />
                            </Toolbar>

                            <Editing
                                mode="popup"
                                useIcons={true}
                                allowAdding={true}
                                allowUpdating={true}
                                allowDeleting={false} >

                                <Popup title="Edit Bin" showTitle={true} width='80vw' height='80vh' />
                                <Form>
                                    <Item dataField="name" colSpan={2} />
                                    <Item dataField="description" colSpan={2} editorType="dxTextArea" editorOptions={{ height: "10rem" }} />
                                </Form>

                            </Editing>
                        </DataGrid >
                    </div>
                }

            </div>

            {addNewLocationDialogVisible &&
                <DialogPopup
                    visible={addNewLocationDialogVisible}
                    onHiding={hideAddNewLocationDialog}
                    dragEnabled={false}
                    hideOnOutsideClick={false}
                    showTitle={true}
                    title="Add Location"
                    width='30rem' height='15rem'>
                    <div>

                        <div className="pw-margin-top-1">
                            <div className="pw-form-unit">
                                <div className="pw-form-unit-label">Location Name</div>
                                <TextBox id="newLocationName" className="selectbox"
                                    onValueChanged={onAddNewLocationValueChanged}
                                    value={newLocationName ? newLocationName : undefined} />
                            </div>
                        </div>

                        <div className="pw-margin-top-1">
                            <div className="pw-form-unit">
                                <div className="pw-form-unit-label">Location Description</div>
                                <TextBox id="newLocationDescription" className="selectbox"
                                    onValueChanged={onAddNewLocationValueChanged}
                                    value={newLocationDescription ? newLocationDescription : undefined} />
                            </div>
                        </div>

                        <div className="pw-comp-row">
                            <div className="pw-centered-buttons-container">
                                <Button id="applySelectionButton"
                                    className="pw-button"
                                    text="Create" type="success"
                                    hint="apply selection"
                                    height='2.1rem'
                                    onClick={onApplyAddLocationClick} />

                                <Button id="cancelButton"
                                    className="pw-button"
                                    text="Cancel" type="normal"
                                    hint="cancel"
                                    height='2.1rem'
                                    onClick={onCancelAddLocationClick} />
                            </div>
                        </div>

                    </div>
                </DialogPopup>
            }

            {toastProps && toastProps.visible &&
                <Toast visible={toastProps.visible}
                    message={toastProps.message}
                    type={toastProps.toastType}
                    onHiding={onToastHiding}
                    displayTime={600} />
            }

            {globalDialogVisible &&
                <GlobalDialog metadata={globalDialogMetadata} />
            }

        </div>
    );

    function onAddNewLocationValueChanged(e: any) {
        if (e.element && e.element.id) {
            if (e.element.id === "newLocationName")
                setNewLocationName(e.value);

            else if (e.element.id === "newLocationDescription")
                setNewLocationDescription(e.value);
        }
    }

    function onAddLocationClick() {
        showAddNewLocationDialog();
    }

    async function onApplyAddLocationClick() {
        let newZone: LocationZone = {
            name: newLocationName,
            description: newLocationDescription
        };

        await insertZone(newZone)
            .then(() => {
                hideAddNewLocationDialog();
                getLocationsTree();
                showToast("Zone saved", "success");
            })
            .catch(res => {
                showMessage(res, ModalMessageType.Error, "Error Inserting Zone");
            });
    }

    function onCancelAddLocationClick() {
        hideAddNewLocationDialog();
    }

    function onLocationNodeClick(e: any) {
        setSelectedZone(e.itemData);

        if (e.itemData.children) 
            setSubItems(e.itemData.children);
            }

    async function onSelectedSubItemRowValidating(e: any) {
        if (e.oldData) {
            let bin: Bin = {
                binId: e.oldData.id,
                name: e.oldData.name,
                description: e.oldData.description
            }

            if (bin) {
                let updatedBin = { ...bin, ...e.newData };

                await updateBin(updatedBin)
                    .then(() => {
                        getLocationsTree();
                        showToast("Bin updated", "success");
                    })
                    .catch((res) => {
                        showMessage(res, ModalMessageType.Error, "Error Updating Bin");
                    });
            }
        }
        else if (e.newData && selectedZone) {
            let bin: Bin = {
                zoneId: selectedZone.id,
                name: e.newData.name,
                description: e.newData.description
            }

            await insertBin(bin)
                .then(data => {
                    getLocationsTree();
                    showToast("Bin saved", "success");
                })
                .catch(res => {
                    showMessage(res, ModalMessageType.Error, "Error Inserting Bin");
                });
        }
    }

    async function getLocationsTree() {
        await CrudFunctions.getData("common/locationstree")
            .then((data) => {
               setLocationsTree(data);
            })
            .catch((res) => {
                showMessage(res, ModalMessageType.Error, "Error Retrieving Locations Tree");
            });
    }

    async function insertZone(zone: LocationZone) {
        return await CrudFunctions.postData("common/locationzone", zone)
    }

    async function insertBin(bin: Bin) {
        return await CrudFunctions.postData("common/locationbin", bin)
    }

    //todo
    async function updateZone(zone: LocationZone) {
        return await CrudFunctions.putData("common/locationzone", zone)
    }

    async function updateBin(bin: Bin) {
        return await CrudFunctions.putData("common/locationbin", bin)
    }

    async function getAllData() {
        await Promise.all([
            getLocationsTree()
        ]);
    }

    //show/hide

    function showAddNewLocationDialog() {
        setAddNewLocationDialogVisible(true);
    }

    function hideAddNewLocationDialog() {
        setAddNewLocationDialogVisible(false);
    }

    function onToastHiding() {
        let toastParams: ToastProps = {
            message: undefined,
            toastType: undefined,
            visible: false
        };

        setToastProps(toastParams);
    }

    function showToast(message: string, toastType: string) {
        let toastParams: ToastProps = {
            message: message,
            toastType: toastType,
            visible: true
        };

        setToastProps(toastParams);
    }

    //other

    function showMessage(res: any, mode: ModalMessageType, title: string) {
        let mm: ModalMetadata = {
            error: res,
            mode: mode,
            title: title
        };

        setGlobalDialogMetadata(mm);
        setGlobalDialogVisible(true);
    }
}